import { cloneDeep } from "lodash";
import template from "./bFlexitimeWorklogForm.html";
import moment from 'moment';

export function bFlexitimeWorklogFormDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bFlexitimeWorklogFormController,
    controllerAs: 'bFlexitimeWorklogForm',
    bindToController: true,
    scope: {
      workspace: "=",
      worklogDates: "=",
      teamLeaderVersion: "=",
      incomingWorklog: "=",
      invoiceDetailsFeatureFlag: "=",
      onSave: "&",
      onCancel: "&",
      onDelete: "&",
      onCopy: "&",
      allowedProjects: "=",
      setupWorklogSource: "&",
      outputTypeFeatureFlag: "=",
      selectedUser: "=",
      overtimeApplicationsFlag: "=",
      billingTypes: "=?",
      user: "=?"
    }
  };

  return directive;
}

class bFlexitimeWorklogFormController {
  constructor($scope, OvertimeApplications) {
    'ngInject';
    window.bFlexitimeWorklogForm = this;
    this.OvertimeApplications = OvertimeApplications;
    this.$scope = $scope;
    this.init();

    this.multiSelectSettings = {
      displayProp: 'name',
      showCheckAll: false,
      showUncheckAll: false,
      smartButtonMaxItems: 10,
      checkBoxes: true,
      scrollableHeight: 'auto',
      scrollable: true,
      enableSearch: false,
    };
  }

  init() {
    this.$scope.$watch(() => this.incomingWorklog, newValue => this.computedPrimary(newValue, this.workspace));
    this.$scope.$watch(() => this.allowedProjects, newValue => this.computedAllowedProjects(newValue));
    this.$scope.$watch(() => this.workspace, newValue => this.computedPrimary(this.incomingWorklog, newValue));
    this.$scope.$watch(() => this.selectedClient, newValue => this.computedSecondary(newValue));
    this.$scope.$watch(() => this.selectedProcessGroupId, newValue => this.computedTertiary(newValue));
    this.$scope.$watch(() => this.selectedProject, newValue => this.computedProject(newValue));
    this.$scope.$watch(() => this.selectedInternalProject, (newValue, oldValue) => JSON.stringify(newValue) !== JSON.stringify(oldValue) && this.computedProject(newValue));
    this.$scope.$watch(() => this.selectedPccId, newValue => this.computedQuaternary(newValue));

    this.$scope.$watch(() => this.selectedDate, newValue => this.validateTime(newValue));
    this.$scope.$watch(() => this.selectedStartTime, newValue => this.validateTime(newValue));
    this.$scope.$watch(() => this.selectedEndTime, newValue => this.validateTime(newValue));

    this.$scope.$watch(() => this.validTime, () => this.validate(this.worklog));
    this.$scope.$watch(() => this.worklog, newValue => this.validate(newValue), true);
  }

  setInitialValues(worklog) {
    const worklogCopy = angular.copy(worklog);
    this.outputs = [];
    this.selectedOutput = undefined;
    return {
      valueAdded: false,
      ...worklogCopy
    };
  }

  computedAllowedProjects(newVal) {
    this.allowedProjects = newVal;
  }

  computedPrimary(worklog, workspace) {
    if (worklog && workspace) {

      this.worklogType = worklog.type;
      this.worklog = this.setInitialValues(angular.copy(worklog));

      const client = workspace.clients.find(client => client.id === worklog.clientId);
      if (worklog.clientId && worklog.billingTypeId || (client && client.defaultBillingTypeId)) {
        this.defaultBillingTypeId = client.defaultBillingTypeId;
        this.defaultBillingTypeName = client.defaultBillingTypeName;
      }

      this.billingTypeOptions = cloneDeep(this.billingTypes);
      if (this.defaultBillingTypeId && !this.billingTypes.some(billingType => billingType.id === this.worklog.billingTypeId))
        this.billingTypeOptions.push({ id: this.worklog.billingTypeId, name: this.worklog.billingTypeName });

      this.selectedDate = worklog.startedAtTime.format("YYYY-MM-DD");

      this.selectedStartTime = worklog.startedAtTime.format("HH:mm");
      this.selectedEndTime = worklog.finishedAtTime.format("HH:mm");
      this.validateTime();

      if (worklog.type == "interrupt") {
        if (worklog.interruptCountryConfigurationId) {
          const interrupt = workspace.interrupts.find((x) => x.id == worklog.interruptCountryConfigurationId);
          this.pickInterruptType(interrupt);
        }
        if (
          worklog.clientId ||
          worklog.interruptName && workspace.interrupts.find(interrupt =>
            interrupt.name === worklog.interruptName
          ).hasClient
        ) {
          this.selectedInterruptTarget = 'client';
        }
        if (
          worklog.serviceLine ||
          worklog.interruptName && workspace.interrupts.find(interrupt =>
            interrupt.name === worklog.interruptName  
          ).hasServiceLine
        ) {
          this.selectedInterruptTarget = 'serviceLine';
        }
      }
      if (worklog.serviceLine) {
        const serviceLine = workspace.serviceLines.find((x) => x == worklog.serviceLine);
        this.pickServiceLine(serviceLine);
      }
      if (worklog.type == "interrupt") {
        let findInternalClient = workspace.clients.find((x) => x.name === "Internal");
        if (findInternalClient && findInternalClient.projects) {
          this.internalProjects = this.fliterProjectsDependsOnFlag(findInternalClient);
        }
        else this.internalProjects = [];

        if (worklog.project && !worklog.clientId) {
          let project = this.internalProjects.find(project => {
            return project.id === worklog.project.id;
          });
          this.selectedInternalProject = project;
        }
        else {
          this.selectedInternalProject = this.internalProjects[0];
        }
        this.selectedProject = this.selectedInternalProject;
      }
      if (worklog.clientId) {
        const client = workspace.clients.find((x) => x.id == worklog.clientId);
        this.selectedClient = client;
        this.clientSearch = client.name;
        this.worklog.serviceLine = undefined;
        this.worklog.clientName = client.name;
        if (worklog.project) {
          // I cannot do just this.selectedProject = worklog.project becasue Anular generete this /$$hashKey ... 
          this.projectsList = this.fliterProjectsDependsOnFlag(client);
          let project = this.getAllProjectsHistoryForClient(client).projects.find(project => {
            return project.id === worklog.project.id;
          });
          this.selectedProject = project;
        }

        const worklogWhichIncludesInterrupt = this.worklogDates
          .map(date => date.worklogs)
          .flat()
          .find(otherWorklog => {
            if (otherWorklog.id === worklog.id && otherWorklog.type !== 'interrupt')
              return false;
      
            return moment(worklog.startedAtTime.format("YYYY-MM-DDTHH:mm:ss")).isBetween(
              moment(otherWorklog.startedAtTime.format("YYYY-MM-DDTHH:mm:ss")),
              moment(otherWorklog.finishedAtTime.format("YYYY-MM-DDTHH:mm:ss")),
              undefined,
              '()'
            );
          }
        );
    
        if (worklogWhichIncludesInterrupt || this.selectedClient.multiselectKeywords && this.selectedClient.multiselectKeywords.length > 0) {
          const client = this.selectedClient || this.workspace.clients.find(client => client.id === worklogWhichIncludesInterrupt.clientId);
    
          if (client.multiselectKeywords && client.multiselectKeywords.length > 0) {
            const selectedKeywords = worklog.clientMultiselectKeywords && worklog.clientMultiselectKeywords.map(keyword => ({id: keyword, name: keyword})) || [];
      
            this.multiselectKeywords = new Array(
              ...client.multiselectKeywords.map(keyword => ({id: keyword, name: keyword})),
              ...selectedKeywords.filter(selectedKeyword => !client.multiselectKeywords.includes(selectedKeyword.id))
            );
      
            this.selectedKeywords = this.multiselectKeywords.filter(keyword => selectedKeywords.map(selectedKeyword => selectedKeyword.id).includes(keyword.id));
          } else
            this.clearKeywordsArrays();
        }
      }
    }
  }

  computedSecondary(client) {
    if (this.worklogType == 'process' && client) {
      this.pcc = this.workspace.processClientConfigurations.filter((x) => x.clientId == client.id);
      this.processes = this.workspace.processes
        .filter((p) => this.pcc.find((pcc) => pcc.processId == p.id))
        .filter((p) => !p.isHidden)
        .map((process) => {
          const ppcc = this.pcc.find((pcc) => pcc.processId == process.id);
          return {
            process: process,
            pcc: ppcc
          };
        });
      this.processGroups = angular.copy(this.workspace.processGroups)
        .sort((a, b) => a.name.localeCompare(b.name)) // copy is a must!!!
        .filter((pg) => this.processes.find((p) => p.process.processGroupId == pg.id));

      if (this.worklog.processClientConfigurationId) {
        this.selectedPccId = this.worklog.processClientConfigurationId;
        this.selectedProcessGroupId = this.processes.find((x) => x.pcc.id == this.worklog.processClientConfigurationId).process.processGroupId;
      }
    }
  }

  computedProject(project) {
    this.worklog.project = project;
  }

  computedTertiary(processGroupId) {
    if (this.worklogType == 'process' && processGroupId) {
      this.worklog.pg = this.processGroups.find(pg => pg.id == processGroupId);
      this.selectedProcessGroupProcesses = this.processes.filter((p) => p.process.processGroupId == processGroupId);
      if (this.selectedProcessGroupProcesses.filter((x) => x.pcc.id == this.selectedPccId).length == 0) {
        this.selectedPccId = undefined;//this.selectedProcessGroupProcesses[0].pcc.id;
      }
    }
  }

  computedQuaternary(pccId) {
    if (this.selectedProcessGroupProcesses && pccId) {
      this.pickProcess();
    }
  }

  pickInterruptType(interruptType) {
    this.selectedInterruptType = interruptType;
    //this.worklog.project = undefined;
    this.selectedInterruptTarget = undefined;
    this.selectedServiceLine = undefined;
    this.selectedClient = undefined;
    this.clientSearch = undefined;

    this.worklog.interruptCountryConfigurationId = interruptType.id;
    this.worklog.interruptId = interruptType.id;
    this.worklog.interruptName = interruptType.name;

    if (interruptType.hasClient && !interruptType.hasServiceLine) {
      this.selectedInterruptTarget = 'client';
      this.worklog.serviceLine = undefined;
    }
    if (!interruptType.hasClient && interruptType.hasServiceLine) {
      this.selectedInterruptTarget = 'serviceLine';
      this.worklog.clientId = undefined;
      this.worklog.clientName = undefined;
    }
    if (!interruptType.hasClient && !interruptType.hasServiceLine) {
      this.worklog.clientId = undefined;
      this.worklog.clientName = undefined;
    }
    if (interruptType.hasClient && interruptType.hasServiceLine) {
      this.worklog.clientId = undefined;
      this.worklog.clientName = undefined;
    }
    this.clearKeywordsArrays();
  }

  showOutputsOption() {
    return this.selectedProcess && this.selectedProcess.process && this.selectedProcess.process.outputs && this.selectedProcess.process.outputs.length > 0;
  }

  cleanInterruptData() {
    this.clientSearch = undefined;
    this.selectedClient = undefined;
    this.selectedServiceLine = undefined;
    this.worklog.clientId = undefined;
    this.worklog.clientName = undefined;
    this.worklog.serviceLine = undefined;
  }

  validateWorklogTimes(selfId, worklogDate, startStr, endStr) {
    const startTime = parseInt(startStr.replace(":", ""));
    const endTime = parseInt(endStr.replace(":", ""));
    const endDate = moment(worklogDate.date.format('YYYY-MM-DD') + ' ' + endStr, 'YYYY-MM-DD HH:mm');

    const arr = worklogDate
      .worklogs
      .filter((x) => !x.deleted)
      .map(
        ({ id, type, startedAtTime, finishedAtTime }) => {
          return {
            id,
            type,
            startedAtTime: parseInt(startedAtTime.format("HHmm")),
            finishedAtTime: parseInt(finishedAtTime.format("HHmm"))
          };
        })
      .filter((x) => x.id != selfId);

    const startOverlapsWith = arr.filter((x) => x.startedAtTime <= startTime && x.finishedAtTime > startTime);
    const finishOverlapsWith = arr.filter((x) => x.startedAtTime < endTime && x.finishedAtTime >= endTime);
    const insideThereIs = arr.filter((x) => x.startedAtTime >= startTime && x.finishedAtTime <= endTime);

    const startInProcess = startOverlapsWith.filter((x) => x.type == "process").length > 0;
    const startInInterrupt = startOverlapsWith.filter((x) => x.type == "interrupt").length > 0;

    const endInProcess = finishOverlapsWith.filter((x) => x.type == "process").length > 0;
    const endInInterrupt = finishOverlapsWith.filter((x) => x.type == "interrupt").length > 0;

    const doesNotStartAndEndInDifferentProcess = !(startInProcess && endInProcess && startOverlapsWith[0].id != finishOverlapsWith[0].id);
    const doesNotStartOrEndInInterrupt = !(startInInterrupt || endInInterrupt);
    const doesNotStartOrEndInProcess = !(startInProcess || endInProcess);
    const hasNoProcessInside = !(insideThereIs.filter((x) => x.type == "process").length > 0);
    const endsBeforeStart = startTime < endTime;
    const notEndsInTheFuture = endDate.isBefore(moment());

    const isValidStartFormat = !!startStr.match(/^[0-9]{2}\:[0-5][0-9]/);
    const isValidEndFormat = !!endStr.match(/^[0-9]{2}\:[0-5][0-9]/);

    return {
      doesNotStartAndEndInDifferentProcess,
      hasNoProcessInside,
      doesNotStartOrEndInInterrupt,
      endsBeforeStart,
      notEndsInTheFuture,
      doesNotStartOrEndInProcess,
      isValidStartFormat,
      isValidEndFormat,
      process:
        doesNotStartOrEndInProcess
        && doesNotStartAndEndInDifferentProcess
        && hasNoProcessInside
        && doesNotStartOrEndInInterrupt
        && endsBeforeStart
        && notEndsInTheFuture
        && isValidStartFormat
        && isValidEndFormat,
      interrupt: doesNotStartAndEndInDifferentProcess
        && hasNoProcessInside
        && doesNotStartOrEndInInterrupt
        && endsBeforeStart
        && notEndsInTheFuture
        && isValidStartFormat
        && isValidEndFormat
    };
  }

  validateTime() {
    const selectedDateInfo =
      this.worklogDates.find((x) => x.date.format("YYYY-MM-DD") == this.selectedDate);

    const timeValidation = this.validateWorklogTimes(this.worklog.id, selectedDateInfo, this.selectedStartTime, this.selectedEndTime);

    this.timeErrors = Object.keys(timeValidation)
      .filter((x) => ['process', 'interrupt'].indexOf(x) == -1)
      .map((x) => {
        return {
          label: "WORKLOG_VALIDATION_ERRORS." + x.toUpperCase(),
          ok: timeValidation[x]
        };
      }).filter((x) => !x.ok);

    this.validTime = timeValidation[this.worklog.type];

    if (this.validTime) {
      this.worklog.startedAtTime = moment(`${this.selectedDate} ${this.selectedStartTime}`).add(10, "millisecond"); //add
      this.worklog.finishedAtTime = moment(`${this.selectedDate} ${this.selectedEndTime}`);
      this.worklog.startedAt = this.worklog.startedAtTime.toISOString();
      this.worklog.finishedAt = this.worklog.finishedAtTime.toISOString();
      this.worklog.duration = moment.duration(this.worklog.finishedAtTime.diff(this.worklog.startedAtTime));
    }
  }

  validate(worklog) {
    this.validateTime();
    this.isVolumeValid = this.selectedProcess && this.selectedProcess.pcc.hasVolume ? parseInt(worklog.volume) >= 0 : true;
    this.canSave = (
      this.validTime
      && this.isVolumeValid
      && !worklog.deleted
      && (
        worklog.interruptCountryConfigurationId
        || worklog.processClientConfigurationId
      )
      && (worklog.type !== 'interrupt' && this.selectedProcess.pcc.hasVolume ? this.worklog.volume % 1 === 0 : true)
    );
    this.canSeeAccept = this.teamLeaderVersion;
    this.canAccept = this.canSave && !worklog.deleted && this.teamLeaderVersion;
  }

  modifyHourBy(time, change = 0) {
    const timeD = moment.duration(time).asHours();
    const newTimeD = timeD + change;
    const h = Math.floor(newTimeD) % 24;
    const hours = h < 0 ? h + 24 : h % 24;
    const minutes = newTimeD - Math.floor(newTimeD);
    const duration = moment.duration(hours + minutes, 'hours');
    return `${('0' + duration.hours()).slice(-2)}:${('0' + duration.minutes()).slice(-2)}`;
  }

  subtractStartHour() {
    this.selectedStartTime = this.modifyHourBy(this.selectedStartTime, -0.25);
  }

  increaseStartHour() {
    this.selectedStartTime = this.modifyHourBy(this.selectedStartTime, 0.25);
  }

  subtractEndHour() {
    this.selectedEndTime = this.modifyHourBy(this.selectedEndTime, -0.25);
  }

  increaseEndHour() {
    this.selectedEndTime = this.modifyHourBy(this.selectedEndTime, 0.25);
  }

  pickServiceLine(serviceLine) {
    //this.worklog.project = undefined;
    this.worklog.serviceLine = serviceLine;
    this.selectedServiceLine = serviceLine;
    this.selectedClient = undefined;
    this.worklog.clientId = undefined;
  }

  clearDataDependedOnClient() {
    this.worklog.serviceLine = undefined;
    this.selectedProcessGroupId = undefined;
    this.selectedPccId = undefined;
    this.selectedProcessGroupProcesses = undefined;
    this.selectedProcess = undefined;
    this.worklog.outputType = undefined;
    this.worklog.processClientConfigurationId = undefined;
    this.outputs = [];
    this.selectedOutput = undefined;
  }

  fliterProjectsDependsOnFlag(client) {
    let source = this.setupWorklogSource({ date: this.worklog.startedAtTime.format("YYYY-MM-DD") });
    if (source) {
      const clientFounded = this.getAllProjectsHistoryForClient(client);
      return clientFounded ? clientFounded.projects.filter(p => p.source == source).filter(p => !(p.status === "Archived" && moment(this.selectedDate).isAfter(moment(p.validUntil)))) : [];
    }
    else return [];
  }

  getAllProjectsHistoryForClient(client) {
    return this.workspace.clientsWithAllProjectsHistory.find(c => c.id == client.id);
  }

  selectAnotherClient() {
    this.worklog.clientId = undefined;
    this.clientSearch = undefined;
    this.selectedClient = undefined;
    this.worklog.applications = null;
    this.worklog.overtimeApplicationId = null;
    this.clearKeywordsArrays();
    this.defaultBillingTypeId = null;
    this.defaultBillingTypeName = null;
    delete this.worklog.billingTypeId;
    delete this.worklog.billingTypeName;
    this.billingTypeOptions = null;
  }

  getPossibleApplicationsForUser(worklog, client, user) {
    worklog.hasOvertimeApplicationInfo = false;
    worklog.applications = [];

    this.OvertimeApplications.getPossibleApplicationsForUser(user, client.id, moment(worklog.startedAt).format("YYYY-MM-DD")).then(
      (success) => {
        worklog.hasOvertimeApplicationInfo = true;
        worklog.applications = success.data.filter(application => (
          application.duration !== application.reportedDuration
          || application.id === worklog.overtimeApplicationId
        ));
      }
    );
  }

  pickClient(client) {
    this.worklog.hasOvertimeApplicationInfo = true;
    if (this.overtimeApplicationsFlag)
      this.getPossibleApplicationsForUser(this.worklog, client, this.selectedUser);
    this.worklog.clientId = client.id;
    if (this.allowedProjects && client.projects && client.projects.length > 0) {
      if (this.setupWorklogSource) {
        let source = this.setupWorklogSource({ date: this.worklog.startedAtTime.format("YYYY-MM-DD") });
        if (source) {
          this.projectsList = this.fliterProjectsDependsOnFlag(client);
          if (this.projectsList.length != 0) this.selectedProject = this.projectsList[0];
        }
      }
    }
    else {
      this.worklog.project = undefined;
    }
    this.selectedClient = client;
    this.clientSearch = client.name;
    this.worklog.clientName = client.name;

    if (client.additionalInfo) {
      this.worklog.clientNameWithAdditionalInfo = `(${client.additionalInfo}) ${this.worklog.clientName}`;
    }

    // if (this.worklog.type === 'process') {
    this.defaultBillingTypeId = this.selectedClient.defaultBillingTypeId;
    this.defaultBillingTypeName = this.selectedClient.defaultBillingTypeName;
    this.worklog.billingTypeId = this.defaultBillingTypeId;
    this.worklog.billingTypeName = this.defaultBillingTypeName;

    if (this.selectedClient.defaultBillingTypeId)
      this.billingTypeOptions = cloneDeep(this.billingTypes);
    // }
    this.clearDataDependedOnClient();

    if (this.selectedClient.multiselectKeywords && this.selectedClient.multiselectKeywords.length > 0) {
      const selectedKeywords = this.worklog.clientMultiselectKeywords && this.worklog.clientMultiselectKeywords.map(keyword => ({id: keyword, name: keyword})) || [];
      this.multiselectKeywords = new Array(
        ...this.selectedClient.multiselectKeywords.map(keyword => ({id: keyword, name: keyword})),
        ...selectedKeywords.filter(selectedKeyword => !this.selectedClient.multiselectKeywords.includes(selectedKeyword.id))
      );

      this.selectedKeywords = this.multiselectKeywords.filter(keyword => selectedKeywords.map(selectedKeyword => selectedKeyword.id).includes(keyword.id));
    } else
      this.clearKeywordsArrays();
  }

  pickProcess() {
    this.outputs = [];
    this.worklog.processClientConfigurationId = this.selectedPccId;
    this.selectedProcess = this.selectedProcessGroupProcesses.find((x) => x.pcc.id == this.selectedPccId);
    this.worklog.volume = this.selectedProcess.pcc.hasVolume ? (this.worklog.volume || 0) : undefined;
    this.worklog.processName = this.selectedProcess.process.name;
    if (this.outputTypeFeatureFlag && this.selectedProcess.pcc.hasVolume && this.showOutputsOption()) {
      if (this.workspace.outputChoices) {
        if (this.workspace.outputChoices[this.selectedProcess.pcc.id]) {
          let outputs = this.workspace.outputChoices[this.selectedProcess.pcc.id].map(element => element.outputType);
          this.outputs = outputs;
          if (!this.worklog.outputType && this.worklog.id === 'new' || !this.worklog.id) {
            this.worklog.outputType = outputs[0];
          }
        }
      }
      this.outputs = this.selectedProcess.process.outputs;
    }
    // add outputType to selected list if was deleted
    if(this.worklog.outputType && !this.outputs.find(element => element === this.worklog.outputType)){
      this.outputs = [this.worklog.outputType, ...this.outputs];
    }
  }

  accept() {
    this.worklog.approved = true;
    this.onSave({
      value: {
        ...angular.copy(this.incomingWorklog),
        approved: true
      }
    });
  }

  save() {
    if (
      this.worklog.interruptId
      && this.selectedInterruptTarget !== 'client'
      && this.internalProjects
      && this.internalProjects.length > 0
      && !this.worklog.clientid
    ) {
      this.worklog.projectId = this.selectedInternalProject.id;
      this.worklog.project = this.internalProjects.find(project => project.id === this.worklog.projectId);
    }
    else if (this.worklog.project) {
      this.worklog.projectId = this.worklog.project.id;
    }
    else {
      this.worklog.projectId = null;
    }
    this.worklog.clientMultiselectKeywords = this.selectedKeywords && this.selectedKeywords.map(keyword => keyword.name);
    var newVersion = angular.copy(this.worklog);
    this.onSave({
      value: {
        ...newVersion,
        valueAddedCorrection: newVersion.valueAdded,
        valueAdded: newVersion.valueAdded
      }
    });
  }

  delete() {
    this.onDelete({ value: this.worklog });
  }

  duplicate() {
    const interrupt = this.workspace.interrupts.find(interrupt => interrupt.name === this.worklog.interruptName);


    this.onCopy({ value: {
      ...this.worklog,
      project: this.selectedProject,
      projectId: this.selectedProject && this.selectedProject.id ? this.selectedProject.id : null,
      interruptId: interrupt && interrupt.id,
      new: true,
      valueAddedCorrection: this.worklog.valueAdded
    }});
  }

  cancel(isBackground) {
    if (this.worklog.id !== "new" || !isBackground) this.onCancel();
  }

  displayMultiselectKeywords(clientMultiselectKeywords) {
    return clientMultiselectKeywords.join(', ');
  }

  chooseClient() {
    this.selectedInterruptTarget = 'client';
    this.clearKeywordsArrays();
  }

  clearKeywordsArrays() {
    this.multiselectKeywords = null;
    this.selectedKeywords = null;
  }
}

